import React from 'react';
import PropTypes from 'prop-types';
import Loader from 'components/Loader';

const ButtonSection = ({
  editEnable,
  isSpecialUser,
  loading,
  labelModify,
  classNameModify,
  labelCancel,
  labelSave,
  onSave,
  onToggle,
}) => (
  <div className="col-lg-4 col-lg-offset-8 col-md-5 col-md-offset-7 col-sm-12 col-xs-12">
    <div className="row">
      {!isSpecialUser && (
        <div
          className={`col-lg-6 col-md-6 col-sm-6 col-xs-12  ${classNameModify}`}
        >
          <button
            type="button"
            className="btn btn-default btn-block margin-top-05"
            onClick={onToggle}
          >
            {editEnable ? labelCancel : labelModify}
          </button>
        </div>
      )}
      {editEnable && (
        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          {loading ? (
            <Loader active={loading} />
          ) : (
            <button
              type="button"
              className="btn btn-primary btn-block margin-top-05"
              onClick={onSave}
            >
              {labelSave}
            </button>
          )}
        </div>
      )}
    </div>
  </div>
);

ButtonSection.propTypes = {
  editEnable: PropTypes.bool,
  isSpecialUser: PropTypes.bool,
  loading: PropTypes.bool,
  labelModify: PropTypes.string,
  classNameModify: PropTypes.string,
  labelCancel: PropTypes.string,
  labelSave: PropTypes.string,
  onSave: PropTypes.func,
  onToggle: PropTypes.func,
};

export default ButtonSection;
